export const NotFound = r => require.ensure([], () => r(require('./404')), '404-bundle');

export default [
  {
    path: '*',
    name: '404',
    component: NotFound
  }
];
